<template>
  <div>
    <Connecting v-if="callState === 'connecting'" :licensePlate="licensePlate" :driver="driver" />
    <FailConnect
      v-if="callState === 'failConnect'"
      :licensePlate="licensePlate"
      :driver="driver"
      :vehicleId="vehicleId"
      @stopCall="stopCall"
      @tryAgain="startCall"
    />
    <OnGoing
      v-if="callState === 'onGoing'"
      :licensePlate="licensePlate"
      :driver="driver"
      :vehicleId="vehicleId"
      :muted="muted"
      @stopCall="stopCall"
      @muteDevice="muteDevice"
      @unmuteDevice="unmuteDevice"
    />
    <InOtherCall
      v-if="callState === 'inOtherCall'"
      :licensePlate="licensePlate"
      :driver="driver"
      :vehicleId="vehicleId"
      @stopCall="stopCall"
      @tryAgain="startCall"
    />
  </div>
</template>

<script>
import Connecting from './CallItemState/Connecting.vue'
import FailConnect from './CallItemState/FailConnect.vue'
import OnGoing from './CallItemState/OnGoing.vue'
import InOtherCall from './CallItemState/InOtherCall.vue'
import Voip from './lib/voip'

export default {
  name: 'CallItem',
  components: {
    Connecting,
    FailConnect,
    OnGoing,
    InOtherCall,
  },
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      type: String,
      required: false,
      default: '',
    },
    callState: {
      type: String, // ENUM: onGoing, connecting, failConnect, inOtherCall
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    imei: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    muted: {
      type: Boolean,
      required: false,
      default: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
    entryPoint: {
      type: String,
      required: false,
      default: '',
    },
    isDebugBroadcast: {
      type: Boolean,
      required: false,
      default: false,
    },
    audioContext: {
      type: AudioContext,
      required: true,
    },
  },
  data() {
    return {
      audio: null,
      isError: false,
      isClosed: false,
      isOpen: false,

      // state for vss
      recorderVss: null,
      audioPlayerVss: null,
    }
  },
  watch: {
    muted: {
      handler(muted) {
        this.handleDeviceMute(muted)
      },
    },
    isError(isError) {
      if (isError) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'failConnect')
        this.$store.commit('video/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.video.voipState[this.vehicleId], state: 'failConnect' },
        })
      }
    },
    isClosed(isClosed) {
      if (isClosed) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'failConnect')
        this.$store.commit('video/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.video.voipState[this.vehicleId], state: 'failConnect' },
        })
      }
    },
    isOpen(isOpen) {
      if (isOpen) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'onGoing')
        this.$store.commit('video/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.video.voipState[this.vehicleId], state: 'onGoing' },
        })
      }
    },
  },
  async mounted() {
    await this.startCall()
  },

  async beforeDestroy() {
    if (this.audio) {
      if (this.deviceType === 'vss-howen') {
        this.stopCallVssHowen()
      } else {
        this.audio.stopCapture()
      }
    }
  },

  methods: {
    muteDevice() {
      this.$emit('setCallsValue', this.vehicleId, 'isMuted', true)
      this.audio.toggleMuteDevice(true)
      this.$forceUpdate()
    },
    unmuteDevice() {
      this.$emit('setCallsValue', this.vehicleId, 'isMuted', false)
      this.audio.toggleMuteDevice(false)
      this.$forceUpdate()
    },
    async startCall() {
      this.$emit('setCallsValue', this.vehicleId, 'state', 'connecting')
      if (this.deviceType === 'vss-howen') {
        // eslint-disable-next-line no-undef
        HWRecorder.get(
          async (rec) => {
            this.recorderVss = rec
            await this.$nextTick()
            this.recorderVss.start()
          },
          {
            sampleBits: 16,
            sampleRate: 8000,
          },
          this.callbackAudioPut
        )
      } else {
        this.audio = new Voip(this.token, this)
        this.$emit('setCallsValue', this.vehicleId, 'state', 'active')
        await this.$nextTick()
        await this.audio.startCapture()
      }
    },
    async callbackAudioPut(arrayOfPcmData) {
      if (this.audioPlayerVss == null) {
        const wsUrl = process.env.VUE_APP_VSS_WS_URL
        const port = process.env.VUE_APP_VSS_PORT
        const serverIp = '52.220.96.82' // TODO : Put this to env
        const wsFullUrl = wsUrl + ':' + port + '/stream?ipaddr=' + serverIp

        const gUserName = this.$store.state.identity.whoami?.email
        const gFuncCode = '3'
        const sessionId = Date.now()
        console.log(gUserName)

        const jsonRequest =
          '{"action":"3001","payload":{"sessionID":"' +
          sessionId +
          '","deviceID":"' +
          this.imei +
          '","channel":"1","workMode":"1","username":"' +
          gUserName +
          '","bussType":"' +
          gFuncCode +
          '"}}'
        // eslint-disable-next-line no-undef
        this.audioPlayerVss = new HWMediaPlayer(wsFullUrl, jsonRequest)
        await this.$nextTick()
        this.audioPlayerVss.setSessionStateCallback(this.callbackSessionStateChangeVss)
        this.audioPlayerVss.play()
        this.$emit('setCallsValue', this.vehicleId, 'state', 'active')
      }
      this.audioPlayerVss.putInAudioPcm(arrayOfPcmData, this.$store.state.voip.isMuted)
    },
    stopCall() {
      if (this.deviceType === 'vss-howen') {
        this.stopCallVssHowen()
      } else {
        this.audio.stopCapture()
      }
      this.$store.commit('voip/removeCalls', this.vehicleId)
      this.$store.commit('video/removeVoipVehicleIdActive', this.vehicleId)
      this.$store.commit('video/deleteVoipState', this.vehicleId)
    },
    toggleMuteMic(isMuted) {
      if (this.audio) {
        this.audio.mediaStream.getAudioTracks().forEach((track) => {
          if (isMuted) {
            track.enabled = false
          } else {
            track.enabled = true
          }
        })
      }
    },
    stopCallVssHowen() {
      if (this.audioPlayerVss) {
        this.audioPlayerVss.stop()
        this.audioPlayerVss = null
      }
      if (this.recorderVss) this.recorderVss.stop()
    },
    handleDeviceMute(muted) {
      if (this.voip) {
        if (muted) {
          this.voip.toggleMuteDevice(true)
        } else {
          this.voip.toggleMuteDevice(false)
        }
        this.$forceUpdate()
      }
    },
  },
}
</script>
